/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidLevelingDecisionsControllerListQueryResponse, BidLevelingDecisionsControllerListQueryParams, BidLevelingDecisionsControllerList401, BidLevelingDecisionsControllerList403 } from "../../models/bidsController/BidLevelingDecisionsControllerList";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { bidLevelingDecisionsControllerList } from "../../clients/bidsService/bidLevelingDecisionsControllerList";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const bidLevelingDecisionsControllerListQueryKey = (params: BidLevelingDecisionsControllerListQueryParams) => [{
  url: '/api/v1/bid-leveling-decisions'
}, ...(params ? [params] : [])] as const;
export type BidLevelingDecisionsControllerListQueryKey = ReturnType<typeof bidLevelingDecisionsControllerListQueryKey>;
export function bidLevelingDecisionsControllerListQueryOptions(params: BidLevelingDecisionsControllerListQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = bidLevelingDecisionsControllerListQueryKey(params);
  return queryOptions<BidLevelingDecisionsControllerListQueryResponse, ResponseErrorConfig<BidLevelingDecisionsControllerList401 | BidLevelingDecisionsControllerList403>, BidLevelingDecisionsControllerListQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return bidLevelingDecisionsControllerList(params, config);
    }
  });
}

/**
 * @summary List a trade's decision log, newest first
 * {@link /api/v1/bid-leveling-decisions}
 */
export function useBidLevelingDecisionsControllerList<TData = BidLevelingDecisionsControllerListQueryResponse, TQueryData = BidLevelingDecisionsControllerListQueryResponse, TQueryKey extends QueryKey = BidLevelingDecisionsControllerListQueryKey>(params: BidLevelingDecisionsControllerListQueryParams, options: {
  query?: Partial<QueryObserverOptions<BidLevelingDecisionsControllerListQueryResponse, ResponseErrorConfig<BidLevelingDecisionsControllerList401 | BidLevelingDecisionsControllerList403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? bidLevelingDecisionsControllerListQueryKey(params);
  const query = useQuery({
    ...bidLevelingDecisionsControllerListQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BidLevelingDecisionsControllerList401 | BidLevelingDecisionsControllerList403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}